var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.743 12.4L26.57 7.307V9.4a3 3 0 01-3 3H9.743z",
    fill: "#FD6020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.377.098c.926 0 1.435.428 1.435 1.237.047.62-.37 1.143-.925 1.238l1.25 1.76h-.973L23.1 2.62h-.092v1.713h-.787V.098h1.157zm-.37 1.951h.231c.51 0 .741-.238.741-.666 0-.38-.231-.619-.74-.619h-.232V2.05zm-3.518 2.284h2.222V3.62h-1.435V2.478h1.389v-.714h-1.39V.812h1.436V.098h-2.222v4.235zm-2.315-1.38L16.11.098h-.834l1.713 4.33h.417l1.712-4.33h-.833l-1.11 2.855zM7.777 2.24c0 1.19.926 2.189 2.083 2.189.37 0 .695-.096 1.019-.238v-.952c-.232.285-.556.476-.926.476A1.322 1.322 0 018.61 2.382v-.095A1.41 1.41 0 019.906.812c.37 0 .741.19.973.476V.336C10.6.146 10.23.098 9.905.098 8.703.003 7.777 1.002 7.777 2.24zm-1.435-.524c-.463-.19-.602-.285-.602-.523.046-.286.278-.524.556-.476.231 0 .463.143.648.333L7.36.479C7.036.193 6.62.003 6.203.003 5.555-.045 5 .479 4.953 1.145v.048c0 .57.232.904.972 1.142.185.047.37.143.556.238A.503.503 0 016.712 3c0 .333-.277.619-.555.619H6.11a.915.915 0 01-.833-.571l-.509.523c.278.523.833.809 1.389.809.74.048 1.342-.523 1.389-1.285v-.143c-.047-.57-.278-.856-1.204-1.237zM3.657 4.333h.787V.098h-.787v4.235zM0 .098h1.389c1.11.048 1.99 1 1.944 2.142 0 .618-.278 1.19-.74 1.618-.417.333-.926.523-1.436.475H0V.098zM1.018 3.62c.37.047.787-.096 1.065-.334.278-.285.417-.666.417-1.094 0-.38-.14-.761-.417-1.047A1.44 1.44 0 001.018.812H.787V3.62h.231z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.24 0c-1.158 0-2.13.952-2.13 2.189 0 1.19.926 2.189 2.13 2.237 1.203.047 2.129-.952 2.175-2.19C15.37 1 14.443 0 13.24 0z",
    fill: "#FD6020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover2);
export default __webpack_public_path__ + "static/media/discover2.78c58dc142a2295a38e2fa65ead18d74.svg";
export { ForwardRef as ReactComponent };